import type { Dictionary } from '@/i18n/de'

export const fr: Dictionary = {
    meta: {
        homeDescription: "Villas de luxe avec ou sans piscine, maisons et appartements de vacances à Zarzis et à Djerba. Demande sans engagement, accompagnement personnel depuis la Tunisie.",
        accommodationsTitle: "Hébergements",
        accommodationsDescription: "Villas avec ou sans piscine, maisons et appartements de vacances à Zarzis et à Djerba. Trouvez votre hébergement en Tunisie.",
        bookingTitle: "Demande de réservation",
        bookingDescription: "Envoyez-nous votre demande de réservation sans engagement pour une villa, une maison ou un appartement de vacances en Tunisie.",
        contactTitle: "Contact",
        contactDescription: "Contactez URLAUB DE LUXE TUNESIEN à El Mouensa, Zarzis. Questions, conseils et demandes de réservation.",
        loginTitle: "Connexion",
        registerTitle: "Inscription",
        verifyTitle: "Confirmer l’e-mail",
        forgotTitle: "Mot de passe oublié",
        privacyTitle: "Confidentialité",
        imprintTitle: "Mentions légales",
        accountTitle: "Mon compte client"
    },
    common: {
        brandLine: "Villas et appartements de vacances en Tunisie",
        save: "Enregistrer",
        saving: "Enregistrement …",
        cancel: "Annuler",
        back: "Retour",
        send: "Envoyer",
        sending: "Envoi en cours …",
        close: "Fermer",
        optional: "facultatif",
        perNight: "par nuit",
        from: "à partir de",
        onRequest: "Prix sur demande",
        guestsUpTo: "jusqu’à {count} personnes",
        bedrooms: "{count} chambres",
        bathrooms: "{count} salles de bain",
        sqm: "{count} m²",
        privatePool: "Piscine privée",
        withPool: "Avec piscine",
        withoutPool: "Sans piscine",
        viewDetails: "Voir les détails",
        requestNow: "Demander maintenant",
        download: "Télécharger",
        open: "Ouvrir",
        yes: "Oui",
        no: "Non",
        nightOne: "1 nuit",
        nightOther: "{count} nuits",
        adultOne: "1 adulte",
        adultOther: "{count} adultes",
        childOne: "1 enfant",
        childOther: "{count} enfants",
        accommodationOne: "1 hébergement",
        accommodationOther: "{count} hébergements",
        choose: "Veuillez choisir",
        commonCountries: "Choix fréquents",
        allCountries: "Tous les pays"
    },
    nav: {
        home: "Accueil",
        accommodations: "Hébergements",
        about: "À propos",
        booking: "Demande de réservation",
        contact: "Contact",
        login: "Connexion",
        register: "Inscription",
        account: "Mon compte",
        logout: "Déconnexion",
        openMenu: "Ouvrir le menu",
        closeMenu: "Fermer le menu",
        language: "Choisir la langue",
        skip: "Aller au contenu"
    },
    types: {
        villa: "Villa",
        house: "Maison de vacances",
        apartment: "Appartement de vacances"
    },
    amenities: {
        pool: "Piscine privée",
        shared_pool: "Piscine commune",
        sea_view: "Vue sur la mer",
        beach_access: "Proche de la plage",
        wifi: "Wi-Fi",
        ac: "Climatisation",
        heating: "Chauffage",
        kitchen: "Cuisine entièrement équipée",
        washing_machine: "Lave-linge",
        tv: "Smart TV",
        parking: "Parking privé",
        garden: "Jardin",
        terrace: "Terrasse",
        rooftop: "Toit-terrasse",
        courtyard: "Patio",
        bbq: "Barbecue",
        housekeeping: "Service de ménage",
        airport_transfer: "Transfert aéroport sur demande",
        baby_cot: "Lit bébé sur demande",
        elevator: "Ascenseur"
    },
    home: {
        heroEyebrow: "Zarzis · Djerba · Tunisie",
        heroTitle: "Vos vacances de luxe en Tunisie",
        heroText: "Des villas, maisons et appartements de vacances soigneusement choisis au bord de la Méditerranée, avec ou sans piscine privée. Un accompagnement personnel par notre équipe à Zarzis.",
        heroPrimary: "Découvrir les hébergements",
        heroSecondary: "Demander sans engagement",
        heroImageAlt: "Villa moderne avec piscine à débordement, palmiers et vue sur la Méditerranée",
        aboutImageAlt: "Maison tunisienne blanche à la porte bleue",
        searchTitle: "Demander la disponibilité",
        searchDestination: "Destination",
        searchArrival: "Arrivée",
        searchDeparture: "Départ",
        searchGuests: "Personnes",
        searchButton: "Commencer la demande",
        anyDestination: "Toutes les destinations",
        highlights: [
            { title: "Sur place à Zarzis", text: "Notre siège est à El Mouensa près de Zarzis, exactement là où vous passez vos vacances." },
            { title: "Soigneusement choisis", text: "Villas, maisons et appartements dans de beaux emplacements, proches de la plage et de la ville." },
            { title: "Demande sans engagement", text: "Votre demande est gratuite. Elle ne devient définitive qu’avec notre confirmation." },
            { title: "En quatre langues", text: "Site, compte client et e-mails en allemand, français, anglais et arabe." }
        ],
        featuredEyebrow: "Nos hébergements",
        featuredTitle: "Villas et appartements sélectionnés",
        featuredText: "De la villa avec piscine à débordement à l’appartement proche de la plage : trouvez l’hébergement qui vous correspond.",
        featuredAll: "Voir tous les hébergements",
        aboutEyebrow: "À propos",
        aboutTitle: "Chez nous à Zarzis, hôtes par passion",
        aboutText1: "URLAUB DE LUXE TUNESIEN propose des villas, maisons et appartements de vacances haut de gamme dans le sud de la Tunisie. Notre siège se trouve à El Mouensa près de Zarzis, à quelques minutes des plages de la Méditerranée.",
        aboutText2: "Nous vous conseillons de manière personnelle et honnête, pour que vous trouviez l’hébergement qui correspond à votre voyage et que vos vacances se déroulent sereinement, du premier contact jusqu’au départ.",
        aboutPoints: [
            "Siège à El Mouensa, 4144 Zarzis",
            "Villas avec et sans piscine",
            "Maisons et appartements de vacances",
            "Contact personnel par e-mail et compte client"
        ],
        categoriesEyebrow: "Pour toutes les envies",
        categoriesTitle: "Trouvez votre hébergement",
        categoryPoolTitle: "Villas avec piscine",
        categoryPoolText: "Intimité, soleil et votre propre piscine.",
        categoryHouseTitle: "Maisons de vacances",
        categoryHouseText: "Des maisons pleines de charme avec patio, jardin et beaucoup de calme.",
        categoryApartmentTitle: "Appartements de vacances",
        categoryApartmentText: "Des appartements confortables près de la plage et de la ville.",
        stepsEyebrow: "C’est simple",
        stepsTitle: "Vos vacances de rêve en trois étapes",
        steps: [
            { title: "Choisir un hébergement", text: "Parcourez nos villas et appartements ou laissez-vous conseiller par notre équipe." },
            { title: "Envoyer la demande", text: "Indiquez vos dates, le nombre de personnes et vos souhaits. Vous recevez immédiatement votre numéro de réservation." },
            { title: "Recevoir la confirmation", text: "Nous vérifions la disponibilité et confirmons votre réservation personnellement par e-mail." }
        ],
        destinationsEyebrow: "Destinations",
        destinationsTitle: "Zarzis et Djerba",
        destinations: [
            { name: "Zarzis", text: "Des plages de sable fin, des oliveraies et une atmosphère détendue. Zarzis est l’endroit idéal pour des journées paisibles au bord de la mer." },
            { name: "Djerba", text: "L’île aux maisons blanches, aux palmiers et au marché animé de Houmt Souk, rapidement accessible depuis Zarzis par la chaussée romaine." }
        ],
        accountEyebrow: "Votre compte client",
        accountTitle: "Tout au même endroit",
        accountText: "Avec votre compte client personnel, vous gardez un œil sur vos demandes, réservations, messages et documents à tout moment.",
        accountPoints: [
            "Statut de vos demandes en ligne à tout moment",
            "Réservations confirmées et passées",
            "Réclamations avec photos",
            "Messages et documents de notre part"
        ],
        accountRegister: "S’inscrire gratuitement",
        accountLogin: "Se connecter",
        ctaTitle: "Prêt pour le soleil, la mer et la détente ?",
        ctaText: "Envoyez-nous votre demande sans engagement. Nous vous répondons personnellement dans les meilleurs délais.",
        ctaButton: "Faire une demande"
    },
    listing: {
        eyebrow: "Villas · Maisons · Appartements",
        title: "Nos hébergements",
        intro: "Villas avec et sans piscine, maisons et appartements de vacances à Zarzis et à Djerba.",
        filterType: "Type",
        filterAll: "Tous",
        filterPool: "Piscine",
        filterPoolAny: "Peu importe",
        filterLocation: "Lieu",
        filterLocationAll: "Tous les lieux",
        filterGuests: "Personnes",
        filterGuestsAny: "Indifférent",
        filterApply: "Afficher",
        filterReset: "Réinitialiser",
        empty: "Nous n’avons pas d’hébergement correspondant à cette sélection pour le moment. Envoyez-nous tout de même une demande, nous vous conseillerons volontiers.",
        emptyButton: "Demander conseil"
    },
    detail: {
        back: "Tous les hébergements",
        guests: "Personnes",
        bedrooms: "Chambres",
        bathrooms: "Salles de bain",
        size: "Surface",
        pool: "Piscine",
        poolYes: "Privée",
        poolNo: "Non",
        aboutTitle: "À propos de cet hébergement",
        amenitiesTitle: "Équipements",
        galleryTitle: "Impressions",
        bookingTitle: "Demander cet hébergement",
        bookingText: "Sans engagement et gratuit. Vous recevez immédiatement votre numéro de réservation.",
        priceNote: "Le prix final dépend de la période et du nombre de personnes.",
        more: "Autres hébergements"
    },
    booking: {
        eyebrow: "Sans engagement et gratuit",
        title: "Demande de réservation",
        intro: "Indiquez-nous vos souhaits. Votre demande est sans engagement. La réservation ne devient définitive qu’avec notre confirmation.",
        sectionTravel: "Votre voyage",
        sectionGuest: "Vos coordonnées",
        sectionWishes: "Souhaits et message",
        destination: "Destination souhaitée",
        destinationFlexible: "Flexible, merci de me conseiller",
        accommodation: "Hébergement souhaité",
        accommodationAdvice: "Pas encore décidé, merci de me conseiller",
        arrival: "Date d’arrivée",
        departure: "Date de départ",
        adults: "Nombre d’adultes",
        children: "Nombre d’enfants",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Adresse e-mail",
        phone: "Numéro de téléphone",
        nationality: "Nationalité",
        specialRequests: "Demandes particulières",
        specialRequestsHint: "Par exemple lit bébé, transfert aéroport ou arrivée tardive",
        message: "Message complémentaire",
        privacyBefore: "J’ai lu la ",
        privacyLink: "politique de confidentialité",
        privacyAfter: " et j’accepte le traitement de mes données pour le traitement de ma demande.",
        submit: "Envoyer la demande",
        submitting: "Envoi de la demande …",
        capacityWarning: "Cet hébergement accueille jusqu’à {count} personnes. Nous vous conseillerons volontiers d’autres options.",
        loggedInAs: "Vous êtes connecté en tant que {name}. La demande apparaîtra automatiquement dans votre compte client.",
        guestHintBefore: "Astuce : avec un ",
        guestHintLink: "compte client gratuit",
        guestHintAfter: ", vous suivez le statut de votre demande en ligne à tout moment.",
        summary: "Votre sélection",
        successTitle: "Merci pour votre demande !",
        successText: "Votre demande nous est bien parvenue. Votre numéro de réservation est :",
        successEmail: "Une confirmation de réception a été envoyée à {email}. Pensez à vérifier aussi vos courriers indésirables.",
        successNoEmail: "Veuillez noter votre numéro de réservation. Nous vous répondrons dans les meilleurs délais.",
        successAccount: "Voir mes demandes",
        successNew: "Faire une autre demande",
        successHome: "Retour à l’accueil"
    },
    auth: {
        email: "Adresse e-mail",
        password: "Mot de passe",
        showPassword: "Afficher le mot de passe",
        hidePassword: "Masquer le mot de passe",
        loginTitle: "Bon retour parmi nous",
        loginText: "Connectez-vous pour voir vos demandes, réservations et messages.",
        forgot: "Mot de passe oublié ?",
        loginButton: "Se connecter",
        loggingIn: "Connexion en cours …",
        noAccount: "Pas encore de compte client ?",
        registerLink: "S’inscrire maintenant",
        notVerifiedAction: "Confirmer mon e-mail",
        registerTitle: "Créer un compte client",
        registerText: "Inscrivez-vous gratuitement et gérez vos demandes et réservations en ligne en toute simplicité.",
        firstName: "Prénom",
        lastName: "Nom",
        phone: "Numéro de téléphone",
        nationality: "Nationalité",
        passwordConfirm: "Confirmer le mot de passe",
        passwordHint: "Au moins 8 caractères",
        privacyBefore: "J’ai lu la ",
        privacyLink: "politique de confidentialité",
        privacyAfter: " et j’accepte le traitement de mes données pour mon compte client.",
        marketing: "Oui, je souhaite recevoir de temps en temps des offres exclusives par e-mail. Je peux retirer ce consentement à tout moment.",
        registerButton: "Créer mon compte",
        registering: "Création du compte …",
        haveAccount: "Déjà inscrit ?",
        loginLink: "Se connecter",
        verifyTitle: "Confirmer votre adresse e-mail",
        verifyText: "Nous avons envoyé un code de confirmation à 6 chiffres à {email}. Veuillez le saisir ici.",
        verifyTextGeneric: "Saisissez votre adresse e-mail et le code à 6 chiffres reçu dans notre e-mail.",
        code: "Code de confirmation",
        verifyButton: "Confirmer l’e-mail",
        verifying: "Vérification …",
        resend: "Envoyer un nouveau code",
        resent: "Si un compte non confirmé existe pour cette adresse, un nouveau code est en route. Pensez à vérifier aussi vos courriers indésirables.",
        verifiedTitle: "Adresse e-mail confirmée",
        verifiedText: "Merci ! Votre compte client est maintenant actif.",
        emailNotSent: "Votre compte a été créé, mais l’e-mail de confirmation n’a pas pu être envoyé pour le moment. Veuillez demander un nouveau code ci-dessous ou réessayer plus tard.",
        forgotTitle: "Réinitialiser le mot de passe",
        forgotText: "Saisissez votre adresse e-mail. Nous vous enverrons un code de sécurité.",
        sendCode: "Envoyer le code",
        codeSent: "Si un compte client existe avec cette adresse, nous vous avons envoyé un code. Pensez à vérifier aussi vos courriers indésirables.",
        resetCode: "Code de sécurité",
        newPassword: "Nouveau mot de passe",
        resetButton: "Enregistrer le nouveau mot de passe",
        resetDone: "Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.",
        backToLogin: "Retour à la connexion",
        sideTitle: "Vos vacances, avec un accompagnement personnel",
        sideText: "Demandes, réservations, réclamations et messages au même endroit."
    },
    errors: {
        required: "Veuillez remplir ce champ.",
        invalid_email: "Veuillez saisir une adresse e-mail valide.",
        invalid_phone: "Veuillez saisir un numéro de téléphone valide.",
        invalid_country: "Veuillez choisir une nationalité.",
        password_short: "Le mot de passe doit contenir au moins 8 caractères.",
        password_mismatch: "Les mots de passe ne correspondent pas.",
        invalid_date: "Veuillez choisir une date valide.",
        date_past: "La date ne peut pas être dans le passé.",
        date_order: "Le départ doit être postérieur à l’arrivée.",
        stay_too_long: "Le séjour ne peut pas dépasser 90 nuits.",
        invalid_number: "Veuillez saisir un nombre valide.",
        consent_required: "Veuillez accepter la politique de confidentialité.",
        invalid_credentials: "Adresse e-mail ou mot de passe incorrect.",
        email_not_verified: "Veuillez d’abord confirmer votre adresse e-mail.",
        account_blocked: "Ce compte client est bloqué. Veuillez nous contacter.",
        email_taken: "Cette adresse e-mail est déjà enregistrée.",
        code_invalid: "Le code est incorrect.",
        code_expired: "Le code a expiré. Veuillez en demander un nouveau.",
        code_locked: "Trop de tentatives. Veuillez demander un nouveau code.",
        rate_limited: "Trop de tentatives. Veuillez patienter un instant puis réessayer.",
        file_type: "Ce type de fichier n’est pas pris en charge. Images, PDF et documents Word sont acceptés.",
        file_too_large: "Les fichiers sont trop volumineux.",
        too_many_files: "5 fichiers au maximum sont possibles.",
        file_invalid: "Le fichier n’a pas pu être lu.",
        upload_failed: "Les fichiers n’ont pas pu être envoyés. Veuillez réessayer.",
        not_cancellable: "Cette demande ou réservation ne peut plus être annulée.",
        wrong_password: "Le mot de passe est incorrect.",
        unauthorized: "Veuillez vous reconnecter.",
        network: "Pas de connexion. Veuillez vérifier votre connexion internet.",
        server_error: "Une erreur est survenue. Veuillez réessayer.",
        validation: "Veuillez vérifier vos saisies.",
        not_found: "Introuvable.",
        forbidden: "Cette action n’est pas autorisée."
    },
    bookingStatus: {
        new: "Reçue",
        in_review: "En cours de traitement",
        confirmed: "Confirmée",
        declined: "Refusée",
        cancelled: "Annulée",
        completed: "Terminée"
    },
    complaintStatus: {
        open: "Ouverte",
        in_progress: "En cours de traitement",
        resolved: "Résolue",
        closed: "Clôturée"
    },
    account: {
        areaTitle: "Mon compte client",
        customerNumber: "Numéro client",
        nav: {
            overview: "Aperçu",
            profile: "Mon profil",
            requests: "Mes demandes de réservation",
            bookings: "Mes réservations confirmées",
            past: "Mes réservations passées",
            cancellations: "Mes annulations",
            complaints: "Mes réclamations",
            messages: "Mes messages",
            documents: "Mes documents",
            settings: "Mes paramètres"
        },
        hello: "Bonjour",
        overviewText: "Retrouvez ici tout ce qui concerne vos voyages avec nous.",
        statOpenRequests: "Demandes ouvertes",
        statUpcoming: "Voyages à venir",
        statComplaints: "Réclamations ouvertes",
        statMessages: "Nouveaux messages",
        nextTrip: "Votre prochain voyage",
        noTrip: "Aucun voyage confirmé pour le moment. Envie de soleil et de mer ?",
        newRequest: "Nouvelle demande",
        recentRequests: "Vos dernières demandes",
        noRequests: "Vous n’avez encore fait aucune demande.",
        viewAll: "Tout voir",
        profileText: "Vos données personnelles. Nous les utilisons pour vos demandes et réservations.",
        emailLocked: "L’adresse e-mail sert d’identifiant. Pour la modifier, envoyez-nous un message.",
        profileSaved: "Vos données ont été enregistrées.",
        memberSince: "Inscrit depuis",
        requestsText: "Les demandes que nous traitons actuellement ainsi que les demandes refusées.",
        bookingsText: "Vos séjours confirmés à venir.",
        pastText: "Vos voyages passés avec nous.",
        cancellationsText: "Demandes et réservations annulées.",
        requestsEmpty: "Vous n’avez actuellement aucune demande en cours.",
        bookingsEmpty: "Vous n’avez actuellement aucune réservation confirmée.",
        pastEmpty: "Vos voyages passés apparaîtront ici.",
        cancellationsEmpty: "Vous n’avez aucune annulation.",
        requestedOn: "Demande du {date}",
        details: "Détails",
        detailTitle: "Réservation",
        timeline: "Historique",
        submitted: "Demande reçue",
        yourDetails: "Vos informations",
        travelDetails: "Dates du voyage",
        noteFromUs: "Message de notre part",
        totalPrice: "Prix total",
        cancelTitle: "Annuler",
        cancelText: "Souhaitez-vous annuler cette demande ou réservation ? Vous recevrez une confirmation par e-mail.",
        cancelReason: "Motif (facultatif)",
        cancelButton: "Annuler la demande ou la réservation",
        cancelConfirm: "Oui, annuler maintenant",
        cancelDone: "Votre annulation a été enregistrée.",
        cancelledByCustomer: "Annulée par vous",
        cancelledByAdmin: "Annulée par nous",
        reportProblem: "Signaler un problème",
        complaintsText: "Déposez une réclamation et suivez l’état de son traitement.",
        newComplaint: "Nouvelle réclamation",
        complaintsEmpty: "Vous n’avez aucune réclamation.",
        complaintSubject: "Objet",
        complaintBooking: "Réservation concernée",
        complaintNoBooking: "Aucune réservation précise",
        complaintMessage: "Votre message",
        complaintMessageHint: "Décrivez aussi précisément que possible ce qui s’est passé.",
        files: "Photos et documents",
        filesHint: "Jusqu’à 5 fichiers (photos, PDF, Word), 10 Mo au total. Les grandes photos sont réduites automatiquement.",
        chooseFiles: "Choisir des fichiers",
        removeFile: "Retirer le fichier",
        complaintSubmit: "Envoyer la réclamation",
        complaintSubmitted: "Votre réclamation {number} a été envoyée.",
        complaintNumber: "Numéro de réclamation",
        submittedOn: "Envoyée le",
        attachments: "Pièces jointes",
        replyLabel: "Votre réponse",
        replyButton: "Envoyer la réponse",
        replySent: "Votre réponse a été envoyée.",
        you: "Vous",
        closedNote: "Cette réclamation est clôturée. Si vous répondez, nous la rouvrirons.",
        messagesText: "Vos messages échangés avec nous.",
        messagesEmpty: "Aucun message pour le moment.",
        newMessage: "Écrire un nouveau message",
        messageSubject: "Objet",
        messageBody: "Message",
        messageSend: "Envoyer le message",
        messageSent: "Votre message a été envoyé.",
        fromUs: "De notre part",
        fromYou: "De votre part",
        documentsText: "Les documents que nous avons mis à votre disposition et vos fichiers envoyés.",
        documentsEmpty: "Aucun document pour le moment.",
        uploadedByYou: "Envoyé par vous",
        providedByUs: "Fourni par nous",
        languageTitle: "Langue des e-mails",
        languageText: "Nous vous envoyons nos e-mails dans cette langue.",
        marketingTitle: "Offres par e-mail",
        marketingText: "Je souhaite recevoir de temps en temps des offres exclusives par e-mail. Je peux retirer ce consentement à tout moment.",
        marketingSince: "Consentement donné le {date}",
        passwordTitle: "Modifier le mot de passe",
        currentPassword: "Mot de passe actuel",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmer le nouveau mot de passe",
        passwordSaved: "Votre mot de passe a été modifié.",
        privacyTitle: "Confidentialité",
        privacyAccepted: "Politique de confidentialité acceptée le {date}",
        deleteTitle: "Supprimer le compte client",
        deleteText: "Votre compte, vos réclamations, messages et documents seront définitivement supprimés. Les données de réservation seront anonymisées. Cette action est irréversible.",
        deleteButton: "Supprimer le compte client",
        deletePassword: "Veuillez saisir votre mot de passe pour confirmer.",
        deleteFinal: "Supprimer définitivement",
        deleted: "Votre compte client a été supprimé.",
        saved: "Enregistré."
    },
    contact: {
        eyebrow: "Nous sommes là pour vous",
        title: "Contact",
        intro: "Écrivez-nous ou envoyez directement une demande de réservation. Nous vous répondons personnellement dans les meilleurs délais.",
        email: "E-mail",
        address: "Adresse",
        phone: "Téléphone",
        whatsapp: "WhatsApp",
        mapLink: "Ouvrir dans Google Maps",
        bookingTitle: "Demander un séjour",
        bookingText: "Le chemin le plus rapide vers votre hébergement : envoyez-nous vos dates et vos souhaits via le formulaire de demande.",
        bookingButton: "Vers la demande de réservation",
        accountTitle: "Déjà client ?",
        accountText: "Écrivez-nous directement depuis votre compte client. Vous gardez ainsi tout l’historique sous les yeux.",
        accountButton: "Écrire un message",
        faqTitle: "Questions fréquentes",
        faq: [
            { question: "Ma demande est-elle engageante ?", answer: "Non. Votre demande est gratuite et sans engagement. Elle ne devient définitive qu’une fois votre réservation confirmée par nos soins." },
            { question: "Ai-je besoin d’un compte client ?", answer: "Non, vous pouvez aussi faire une demande sans compte. Avec un compte client, vous voyez cependant à tout moment le statut de vos demandes ainsi que vos réservations, messages et documents." },
            { question: "Comment annuler une demande ou une réservation ?", answer: "Connectez-vous à votre compte client et ouvrez la demande ou la réservation. Vous pourrez l’y annuler. Sans compte, envoyez-nous simplement un e-mail avec votre numéro de réservation." },
            { question: "Comment déposer une réclamation ?", answer: "Dans votre compte client, rubrique « Mes réclamations ». Vous pouvez joindre des photos et des documents et suivre le traitement à tout moment." }
        ]
    },
    footer: {
        about: "Villas, maisons et appartements de vacances à Zarzis et à Djerba, avec un accompagnement personnel depuis El Mouensa.",
        explore: "Découvrir",
        service: "Service",
        contact: "Contact",
        privacy: "Confidentialité",
        imprint: "Mentions légales",
        rights: "Tous droits réservés."
    },
    legal: {
        privacyTitle: "Politique de confidentialité",
        privacyUpdated: "Version : novembre 2026",
        privacy: [
            { heading: "Responsable du traitement", body: "Le responsable du traitement de vos données sur ce site est URLAUB DE LUXE TUNESIEN, El Mouensa, 4144 Zarzis, Tunisie. Vous pouvez nous joindre par e-mail à urlaub.de.luxe.info@gmail.com." },
            { heading: "Données traitées", body: "Lorsque vous créez un compte client, nous enregistrons votre prénom, votre nom, votre adresse e-mail, votre numéro de téléphone et votre nationalité. Votre mot de passe est uniquement enregistré sous forme d’empreinte sécurisée et irréversible. Pour les demandes de réservation, nous traitons également la destination, l’hébergement, les dates, le nombre de personnes ainsi que vos souhaits et messages. Pour les réclamations, nous enregistrons votre description ainsi que les photos et documents que vous envoyez." },
            { heading: "Finalités et bases juridiques", body: "Nous traitons vos données pour répondre aux demandes, exécuter les réservations, mettre votre compte client à disposition et traiter les réclamations (art. 6, par. 1, point b du RGPD). Nous n’envoyons des offres par e-mail qu’avec votre consentement explicite (art. 6, par. 1, point a du RGPD), que vous pouvez retirer à tout moment dans votre compte client. Pour prévenir les abus, nous traitons des données techniques telles qu’un identifiant IP pseudonymisé (art. 6, par. 1, point f du RGPD)." },
            { heading: "E-mails", body: "Nous envoyons les confirmations et les messages via le service e-mail de notre prestataire de site web. Pour les e-mails au format HTML, l’ouverture d’un e-mail et les clics sur les liens sont enregistrés techniquement. Nous utilisons ces informations uniquement pour garantir la bonne distribution de nos e-mails. Les adresses auxquelles les e-mails ne peuvent durablement pas être distribués sont bloquées automatiquement." },
            { heading: "Cookies et statistiques de visite", body: "Nous utilisons uniquement un cookie techniquement nécessaire pour que vous restiez connecté. Nous n’utilisons pas de cookies publicitaires ni de suivi. Pour les statistiques de visite, nous utilisons un procédé sans cookies qui ne crée aucun profil personnel." },
            { heading: "Lieu et durée de conservation", body: "Vos données sont hébergées chez notre prestataire d’hébergement, les fichiers dans un espace de stockage protégé et non public. Nous conservons vos données tant que votre compte client existe ou que des obligations légales de conservation l’exigent. Si vous supprimez votre compte, vos données personnelles, réclamations, messages et documents sont supprimés et les données de réservation anonymisées." },
            { heading: "Vos droits", body: "Vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation du traitement, de portabilité et d’opposition, ainsi que du droit de retirer à tout moment un consentement donné. Vous pouvez supprimer vous-même votre compte client à tout moment dans « Mes paramètres ». Vous pouvez également introduire une réclamation auprès d’une autorité de protection des données." },
            { heading: "Contact pour la protection des données", body: "Pour toute question relative à la protection des données, écrivez-nous à urlaub.de.luxe.info@gmail.com." }
        ],
        imprintTitle: "Mentions légales",
        imprintProvider: "Éditeur",
        imprintRepresented: "Représenté par",
        imprintContact: "Contact",
        imprintEmail: "E-mail",
        imprintPhone: "Téléphone",
        imprintResponsible: "Responsable du contenu",
        imprintDisclaimerTitle: "Responsabilité quant au contenu",
        imprintDisclaimer: "Le contenu de ce site a été élaboré avec le plus grand soin. Nous ne pouvons toutefois garantir l’exactitude, l’exhaustivité et l’actualité des contenus. Seules les informations figurant dans notre confirmation de réservation écrite font foi."
    },
    notFound: {
        title: "Page introuvable",
        text: "La page demandée n’existe pas ou a été déplacée.",
        button: "Retour à l’accueil"
    }
}
